export const translateHour = (t, value) =>
  translateWordForm(t, 'unit.hour', 'unit.hours', value);

export const translateMinute = (t, value) =>
  translateWordForm(t, 'unit.minute', 'unit.minutes', value);

export const translateWordForm = (t, key, keys, value) => {
  return value !== 1 ? t(keys, { value }) : t(key, { value });
};
